module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Light.117f6877.ttf";